exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dashboard h1{font-size:22px}#dashboard .box-card{width:70%;margin:0 auto}#dashboard .underlined{text-decoration:underline}", ""]);

// exports
